export const MessageTemplate = `
  <span class='message__user'>{{{user}}}</span>
  <span>{{{text}}}</span>
  <span class="message__time">{{{time}}}</span>
`;
